import { useRef } from 'react';

import { TabProps } from 'types/tabs';

import './styles.css';

const RoundedTabs = ({
  tabs,
  onTabSelect,
  selectedTab,
  className,
  buttonClassName,
  borderClassName
}: TabProps) => {
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([]);

  return (
    <div className={`relative flex ${className || ''}`}>
      {tabs?.map((tab, index) => (
        <button
          ref={(el) => {
            tabRefs.current[index] = el;
          }}
          type="button"
          className={`rounded-tab flex min-w-25 cursor-pointer flex-col pb-2 md:min-w-30 ${
            selectedTab?.id === tab.id ? 'active-tab' : ''
          } ${buttonClassName}`}
          key={tab.id}
          onClick={() => {
            onTabSelect?.(tab);
          }}
          tabIndex={0}
          aria-selected={selectedTab?.id === tab.id}
          role="tab"
        >
          <div
            className={`relative flex justify-center gap-2 rounded-t-lg border-b-0 px-6 py-2 pb-0 text-center text-base font-medium ${
              selectedTab?.id === tab.id
                ? 'round-border border border-grey30 text-primary'
                : 'border border-transparent text-content'
            } ${borderClassName}`}
            key={tab.id}
          >
            {tab.label}
            {(tab.count || tab.count === 0) && (
              <div
                className={`rounded-full px-4 py-1 text-sm font-normal text-content ${
                  selectedTab?.id === tab?.id ? 'bg-primary20' : 'bg-grey90'
                }`}
              >
                {tab.count}
              </div>
            )}
          </div>
        </button>
      ))}
    </div>
  );
};

export default RoundedTabs;
